export default __webpack_public_path__ + "7de3ca396d71b1266a8b9787e9442da6.svg";